<template>
    <div class="qrOptions">
        <div
            class="qrOptionGroup tooltipElement"
        >
            <label>{{ $t('editorSceneElementOptionsSize') }}</label>
            <input
                type="number"
                v-model="size"
                @input="changeQrSize()"
                :ref="`size`"
            >
            <span>px</span>
            <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsSetQRSize') }`" />
        </div>
        <div
            class="qrColors tooltipElement"
            :class="isActive ? 'active' : ''"
        >
            <div
                class="qrColors_trigger"
                :class="isActive ? 'tooltipHide' : ''"
                @click="isActive = !isActive"
            >
                <span>{{ $t('editorSceneElementOptionsColors') }}</span>
                <inline-svg
                    :src="colors_icon"
                    :fill="isActive ? `#${this.getSessionDetails.editorSetup.colors.primaryColor}` : '#707070'"
                />
            </div>
            <div class="qrColors_container">
                <ColorPicker :colorSide="`frontColor`" />
                <ColorPicker :colorSide="`backColor`" />
            </div>
            <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsSetQRColor') }`" />
        </div>
        <Placeholder />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ColorPicker from '../ElementsOptions/colorPickerQr.vue';
    import Placeholder from '../ElementsOptions/placeholders.vue';
    import Tooltip from '@/components/Global/Tooltip.vue';
    import colors_icon from '@/assets/icons/colors_icon.svg';
    import { qrSvg } from '../../../js/qrCodeSvg';

    export default {
        data() {
            return {
                sizes: [
                    {
                        width: 150,
                        name: 'width'
                    },
                    {
                        height: 150,
                        name: 'height'
                    }
                ],
                size: 150,
                isActive: false,
                colors_icon
            }
        },
        methods: {
            changeQrSize() {
                this.$nextTick(() => {
                    this.$refs['size'].focus();
                });

                this.$store.dispatch('UPDATE_ELEMENT', {
                    ...this.getActiveElement,
                    width: this.size,
                    height: this.size,
                    webSizeMM: {
                        ...this.getActiveElement.webSizeMM,
                        width: this.size * 0.084667,
                        height: this.size * 0.084667
                    }
                });

                qrSvg(this.getActiveElement.content, this.getActiveElement.frontColor, this.getActiveElement.backColor, this.size, this.getActiveElement.id);
            },
            changeQrValue(value, index) {
                this.$nextTick(() => {
                    this.$refs[value][0].focus();
                })

                this.$store.dispatch('UPDATE_ELEMENT', {
                    ...this.getActiveElement,
                    [value]: parseInt(this.sizes[index][value]),
                    webSizeMM: {
                        ...this.getActiveElement.webSizeMM,
                        [value]: this.sizes[index][value] * 0.084667
                    }
                })
            }
        },
        computed: {
            ...mapGetters([
                'getSessionDetails',
                'getActiveElement'
            ])
        },
        mounted() {
            this.sizes[0].width = this.getActiveElement.width;
            this.sizes[1].height = this.getActiveElement.height;

            this.size = this.getActiveElement.width; 
        },
        components: {
            ColorPicker,
            Placeholder,
            Tooltip
        }
    }
</script>

<style lang="scss" scoped>
    .qrOptions {
        display: flex;

        .qrOptionGroup {
            display: flex;
            align-items: center;
            color: #707070;
            font-size: 12px;
            margin-right: 10px;
            padding-right: 10px;
            border-right: 1px solid #D4D4D4;

            label {
                text-transform: capitalize;
            }

            input {
                padding: 6px;
                width: 65px;
                box-sizing: border-box;
                border-radius: 3px;
                border: 1px solid #ffffff;
                margin: 0 10px;
            }
        }
    }
    .qrColors {
        position: relative;
        padding-right: 10px;
        border-right: 1px solid #D4D4D4;
        color: #707070;
        font-size: 12px;

        .qrColors_trigger {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px;
        }

        .qrColors_container {
            display: none;
            padding: 15px 15px 5px 15px;
            background-color: #f5f5f5;
            box-shadow: 5px 8px 10px 0px #D4D4D4;
            position: absolute;
            width: 150px;
            top: 34px;
        }

        &.active {
            .qrColors_container {
                display: block;
            }
        }
        &:hover {
            svg {
                fill: var(--primary-color);
            }
        }
    }
</style>